import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CoachGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  canActivate(): boolean {
    // console.log('this.authService.coachLoggedIn() : ', this.authService.coachLoggedIn());

    if (this.authService.coachLoggedIn()) {
      return true;
    }


    else {

      this.router.navigate(['login']);
      return false;
    }
  }
}

